/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Art_Value_TotalInputs */

const en_svc_integration_art_value_total = /** @type {(inputs: Svc_Integration_Art_Value_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`€1,240.00`)
};

const lv_svc_integration_art_value_total = /** @type {(inputs: Svc_Integration_Art_Value_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 240,00 €`)
};

/**
* | output |
* | --- |
* | "€1,240.00" |
*
* @param {Svc_Integration_Art_Value_TotalInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_art_value_total = /** @type {((inputs?: Svc_Integration_Art_Value_TotalInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Art_Value_TotalInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_art_value_total(inputs)
	return en_svc_integration_art_value_total(inputs)
});